import React, { PureComponent } from "react";
import { ClassificationLayer, GradientLayer, Source, RasterSource, Layer, RasterLayer } from "@gago-react-gl/gago-react-gl";
import { getPublisherUrls } from "../../utils/common-function";
import { ClassificationLegend3, GradientSimpleLegend2, GradientIntervalLegend2 } from "@gago/frame";
import { colorPalette } from "../../color-palette";
// tslint:disable:jsx-no-multiline-js max-classes-per-file
interface DateProps {
  /** 选择事件 */
  date: string;
}
/**
 * 乡村绿化图层
 * @author 马俊峰
 * @date 2020-08-06
 * @export
 * @class GreeningTypeLayer
 * @extends {PureComponent}
 */
export class GreeningTypeLayer extends PureComponent<DateProps> {
  render() {
    const { date } = this.props;
    return (
      <>
        <ClassificationLayer<{ c0: "c0" }>
          id="village_floating_layer"
          url={`https://api.gagogroup.cn/publisher/v2/data/greeningdata/${date}1231/{z}/{x}/{y}/lerc?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd`}
          paintUrl={"https://api.gagogroup.cn/publisher/v2/colour/greeningdata?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd"}
          insideSorts={{ c0: [-1, 10] }}
          insideActiveSorts={"all"}
          before="village_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <ClassificationLegend3
              {...{ ...colors }}
              theme="dark"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
              names={["绿化"]}
              colorPalette={colorPalette}
            />
          )}
        </ClassificationLayer>
      </>
    );
  }
}

/**
 * 乡村灯光地图图层
 * @author 马俊峰
 * @date 2020-08-06
 * @export
 * @class LightTypeLayer
 * @extends {PureComponent<DateProps>}
 */
export class LightTypeLayer extends PureComponent<DateProps> {
  render() {
    const { date } = this.props;
    return (
      <>
        <GradientLayer
          id="village_floating_layer"
          url={getPublisherUrls(`https://api.gagogroup.cn/publisher/v2/data/light_annu/${date}0101/{z}/{x}/{y}/lerc?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd`)}
          paintUrl={"https://api.gagogroup.cn/publisher/v2/colour/light_annu?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd"}
          before="village_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <GradientSimpleLegend2
              {...{ ...colors }}
              theme="dark"
              title="夜光"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
              names={["较低", "较高"]}
              colorPalette={colorPalette}
            />
          )}
        </GradientLayer>
      </>
    );
  }
}

/**
 * 地图图层
 * @author 马俊峰
 * @date 2020-08-10
 * @export
 * @class ZengCengBaseMapLayer
 * @extends {PureComponent}
 */
export class ZengCengBaseMapLayer extends PureComponent {
  render() {
    return (
      <>
        <Source<RasterSource>
          type="raster"
          id="zengcheng_base_map_layer_source"
          tileSize={256}
          // tslint:disable-next-line:ter-max-len
          tiles={[`${window.config.publisher}/api/v1/cloud/6map/GZZC_Map_V1/mapnik/{z}/{x}/{y}.png`]}
          scheme="xyz"
        />
        <Layer<RasterLayer>
          id="village_floating_layer"
          type="raster"
          source="zengcheng_base_map_layer_source"
          before="village_outline_layer"
        />
      </>
    );
  }
}
